export interface LineSelectionInput {
  orderedIds: string[];
  selectedIds: string[];
  clickedId: string;
  anchorId: string;
  toggle: boolean;
  range: boolean;
}

export interface LineSelectionResult {
  selectedIds: string[];
  anchorId: string;
}

/** Apply host-normalized list selection semantics (Cmd/Ctrl toggle, Shift range). */
export function selectLine(input: LineSelectionInput): LineSelectionResult {
  const clickedIndex = input.orderedIds.indexOf(input.clickedId);
  if (clickedIndex < 0) return { selectedIds: input.selectedIds, anchorId: input.anchorId };

  if (input.range) {
    const anchorIndex = input.orderedIds.indexOf(input.anchorId);
    const start = anchorIndex < 0 ? clickedIndex : Math.min(anchorIndex, clickedIndex);
    const end = anchorIndex < 0 ? clickedIndex : Math.max(anchorIndex, clickedIndex);
    const rangeIds = input.orderedIds.slice(start, end + 1);
    const selectedIds = input.toggle
      ? input.orderedIds.filter((id) => input.selectedIds.includes(id) || rangeIds.includes(id))
      : rangeIds;
    return { selectedIds, anchorId: anchorIndex < 0 ? input.clickedId : input.anchorId };
  }

  if (input.toggle) {
    const selectedIds = input.selectedIds.includes(input.clickedId)
      ? input.selectedIds.filter((id) => id !== input.clickedId)
      : input.orderedIds.filter((id) => input.selectedIds.includes(id) || id === input.clickedId);
    return { selectedIds, anchorId: input.clickedId };
  }

  return { selectedIds: [input.clickedId], anchorId: input.clickedId };
}
